import React from 'react';
import { Modal } from '@amzn/storm-ui';
import { PartitionedBanners } from '../types';
import { ConsolidatedBannerModalItems } from 'src/commons/components/ConsolidatedBanner/ConsolidatedBannerModalItems';
import { BANNER_LEVEL } from 'src/app/slice';

interface BannersModalProps {
  partitionedBanners: PartitionedBanners;
  header?: string;
  isModalOpen: boolean;
  onClose: any;
  bannerLevel: BANNER_LEVEL;
}

export const BannersModal: React.VFC<BannersModalProps> = ({
  partitionedBanners,
  header = '',
  isModalOpen,
  onClose,
  bannerLevel,
}) => {
  const bannersInOrder = [
    ...partitionedBanners.error,
    ...partitionedBanners.warning,
    ...partitionedBanners.info,
  ];

  return (
    <Modal
      data-testid="consolidated-banner-modal"
      header={header}
      isOpen={isModalOpen}
      onClose={onClose}
      modalElementId="AACChromePortal"
      padding="small"
    >
      <ConsolidatedBannerModalItems
        banners={bannersInOrder}
        bannerLevel={bannerLevel}
      />
    </Modal>
  );
};
